
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index7F6rxR6ttp8ULx55M14kcWwgamF7PHHwKq587lwp_xMMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/index.vue?macro=true";
import { default as portfolio0mB0tgfp8E5Vh5QdaX368WvoHqJBvlq1Al9MM32GaLMMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/portfolio.vue?macro=true";
import { default as _91step_93VW0vCDjjydLqksOZtRUFqfbTYJvMTVBbc5_454ZsIIlMQMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/signup/[step].vue?macro=true";
import { default as translation1eMxIDe6Hhp4OTNheGSnf4jloIIh6z2liBiqmHy6xwgMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/admin/translation.vue?macro=true";
import { default as _91step_93hAEXXNRI4Lo_45CvOfo_450GYotaHhDq0VMkqiDKCzoWJmwMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/completion/[step].vue?macro=true";
import { default as edit_45availabilityiGPqKzhlEYVr67TXtDQUeyULnvg_0_SETHGAbijjpyUMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/[profileIdOrAlias]/edit-availability.vue?macro=true";
import { default as _91profileIdOrAlias_93IHn5ZQq3Scr8hz0sOvz4KQFcVuvRyDSb2wBCzwgMWDYMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/[profileIdOrAlias].vue?macro=true";
import { default as _91experienceId_93_46clientsfrAhn_45_45CjWILhA5YR9H1THz_451mLOZs_9F6gNaXticUMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/experiences/[experienceId].client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/nuxt@3.17.3_@parcel+watcher@2.4.1_@types+node@20.14.2_db0@0.3.2_encoding@0.1.13_eslint@8.35.0_qhy4nvb3enfonziow46a3osdqm/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as experiences_46clientPVYt_ambgcX4_CtSQ5C6fnpcVQiAuq1UpuRuqIMBS90Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/experiences.client.vue?macro=true";
import { default as sandboxv4onpqxEL3IXU47Zkhml7H0qyc3viE6Cvtmj6Ufa0JgMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/mf/profile/sandbox.vue?macro=true";
import { default as indexI_45rMbTYDljsWTLf_Deo0Fh_bvjIc8fXeB3JxzG5JXwsMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/recommendations/index.vue?macro=true";
import { default as demo6baGCBlLHGQPawdCcTq_3puJHB1QzuBSg8QkrGliZvgMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/demo.vue?macro=true";
import { default as your_45skillsdsrZDs95tnydRDc9En9vj78L59ExaHN6Ed6ZaWTibPoMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-skills.vue?macro=true";
import { default as welcome_45backjoHl9SIAFNlqTbJTUQd4XejR46lYVTC2LwKHZFk_45mD8Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/welcome-back.vue?macro=true";
import { default as your_45educationYYgegX3zzXSsPluMj3wSshAeTPdPAk6xWV96on4RxYMMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-education.vue?macro=true";
import { default as your_45daily_45rateIqDTUGR3cIR5Cf74rLXE4ihES2xxkYLGXVZRAKSXdU8Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-daily-rate.vue?macro=true";
import { default as your_45top_45skillsEHrO0hpvd5TFSR0dZB4kMuS_457QuX4_eSvhCGAQqAtH8Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-top-skills.vue?macro=true";
import { default as verify_45your_45emailFSEEMi_45oDdH5EzOL_9o0jV0C1wBu5Cagni2jopplA50Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/verify-your-email.vue?macro=true";
import { default as your_45phone_45numberg24dHwSShtMigleoMKkc5MaCR6mMm8m69Zi51aW8WAgMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-phone-number.vue?macro=true";
import { default as create_45your_45account1pYJh_45GapjMyoHuQa5ICnfRQdrNHqGRTpVvjNHZAM6MMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/create-your-account.vue?macro=true";
import { default as redirect_45to_45regularXbWoJ7JQV_45qbEKAkRWZYl9YZ7h_45akD0oRpr1t25uqBQMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/redirect-to-regular.vue?macro=true";
import { default as welcome_45to_45malt_45openmv33wcI_45Wy3yFCbIJQ9rhMbkZxCoq9U5Mf5TjeClTTcMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/welcome-to-malt-open.vue?macro=true";
import { default as your_45profile_45picture90CylNXRcS2je3uZH38ISYtpGRlET0TPQnzgareYewAMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-profile-picture.vue?macro=true";
import { default as your_45work_45experiencegtEuz8FbxIO5Rz8_455c1slB1o8VNrxhQ6f9Or3VaNLEwMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-work-experience.vue?macro=true";
import { default as complete_45your_45accountTsyoDkU5zcSbL7PMhOGrVFgyHaf4ObKQ4QgC5McW5B4Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/complete-your-account.vue?macro=true";
import { default as showcase_45your_45talentskO1RY7vwfb_Zh_0F7wYS7srYu3r96oatLM6tNzxzhGoMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/showcase-your-talents.vue?macro=true";
import { default as your_45privacy_45settingsRmnaYGb9uRfNb9BxiWbgk4V3S3PYTFX_457Fz_457_hSExMMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-privacy-settings.vue?macro=true";
import { default as your_45working_45languagesf6gpn_2xxlP0aENrrEhVzTUwzWch35pJ683B1ienAX8Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-working-languages.vue?macro=true";
import { default as submit_45your_45applicationKKME21288OeKXz1EaNP_IEdEYbK_Gy7r3LRg6np3Xt0Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/submit-your-application.vue?macro=true";
import { default as your_45industry_45expertiseDJcndSYjbO5d7zlLBBITM69LxS5SCCMmJvNa87makAgMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-industry-expertise.vue?macro=true";
import { default as welcome_45to_45malt_45strategyyqBlEnTW2bhOmHTNToUmE6YhryJ2jcs5DBLNvZWN6icMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/welcome-to-malt-strategy.vue?macro=true";
import { default as your_45level_45of_45experience8aIMPZD06uBM1OhcdBFAyo7GGpZetqEeV8_45DX61OnqcMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-level-of-experience.vue?macro=true";
import { default as create_45your_45account_45splitW2k_45FUdidGcLw0kAFbbs6svK47TlSgZhLmk7lcteWBkMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/create-your-account-split.vue?macro=true";
import { default as your_45freelancing_45experienceINAG2jCy4j3dedtQkoOhjvMoEetg4mBNECVE0fJy6u4Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-freelancing-experience.vue?macro=true";
import { default as your_45job_45title_45and_45categoryqVRLbwVuiR6qGACuVI3DFtZM9B5m5zzCnlZp50tbvnEMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-job-title-and-category.vue?macro=true";
import { default as how_45would_45you_45describe_45yourselfU2VEp4azGSO8Q5nTQL0viuEN8P7mrw8BEdnyX939JBEMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/how-would-you-describe-yourself.vue?macro=true";
import { default as welcome_45to_45malt_91_91funnelContext_93_93VROXo3dE_fqUAxqXdkZW_YjDmUPG9lE6vqIY73dgYXAMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/welcome-to-malt[[funnelContext]].vue?macro=true";
import { default as your_45location_45and_45workplace_45preference2z5CNnwsA2QueaqwXSY_45_45c8ouA_459td_45iLie3ktjdB2cMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-location-and-workplace-preference.vue?macro=true";
import { default as indexczYuNOGpgeSZl_lyA4PIvW3DqosReQImlPeGWwbKtAwMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index.vue?macro=true";
import { default as indexTzqiNYKN_45X1Qrv06ZxN3ElzxqL_RbHWkjG1NT9DeZQUMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-charter/index.vue?macro=true";
import { default as pdfwwGd20Eu8cjkwmtgiOgCPTSMbl9Oiw5Jlgmjuft1rr4Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/cv/[profileIdOrAlias]/pdf.vue?macro=true";
import { default as index1GepqszjwZxnn9gP3JoKEhf8gQQOZCAmwcjq43GzbYYMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/mission-preferences/index.vue?macro=true";
import { default as indexk0hvrFdVlc1E6_451S04eP_45ukf5SylrE1IYR7IZg6VKsoMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/cv/[profileIdOrAlias]/index.vue?macro=true";
import { default as _91profileId_93XcZ7P3zthTJ9C6nYjdZkoL6n6Lsp5PTuCOsfa_owfckMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/edit-availability/[profileId].vue?macro=true";
import { default as _91profileIdOrAlias_93ES8vP6rp7Xu0IYWhoNdojBdumI1PBf0LjfYNuVWN6uEMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/mf/profile/[profileIdOrAlias].vue?macro=true";
import { default as auth_45confirmedsPkaXH5XwTLoupUZJUnzQzGC15l4uPXP9hXM14omEb8Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/reputation-provider/auth-confirmed.vue?macro=true";
import { default as starterVIM_JA9ERBK9r8cFFodkirQ8zZFUTX9nbr_vZ12IyQsMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/mf/profile-qualification-panel/starter.vue?macro=true";
import { default as strategyM2Z1tJHbR4YC9N1IDs4GXQKXaKtlzEA0f87Q3y_45KHBoMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/waiting-room/strategy.vue?macro=true";
import { default as reminder_45_91reminderToken_93jlFaoaPnLHMdyaUzgv7AbCSEByVvOS2lOEljulvEEZsMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/reminder-[reminderToken].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: {"middleware":"profile-redirect"},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/index.vue")
  },
  {
    name: "portfolio",
    path: "/portfolio",
    meta: { ...(portfolio0mB0tgfp8E5Vh5QdaX368WvoHqJBvlq1Al9MM32GaLMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/portfolio.vue")
  },
  {
    name: "signup-step",
    path: "/signup/:step()",
    meta: {"middleware":["external-redirect"]},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/signup/[step].vue")
  },
  {
    name: "admin-translation",
    path: "/admin/translation",
    meta: { ...(translation1eMxIDe6Hhp4OTNheGSnf4jloIIh6z2liBiqmHy6xwgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/admin/translation.vue")
  },
  {
    name: "completion-step",
    path: "/completion/:step()",
    meta: {"middleware":["external-redirect"]},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/completion/[step].vue")
  },
  {
    name: "profileIdOrAlias",
    path: "/:profileIdOrAlias()",
    meta: { ...(_91profileIdOrAlias_93IHn5ZQq3Scr8hz0sOvz4KQFcVuvRyDSb2wBCzwgMWDYMeta || {}), ...{"middleware":["profile-alias-and-other-redirect"]} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/[profileIdOrAlias].vue"),
    children: [
  {
    name: "profileIdOrAlias-edit-availability",
    path: "edit-availability",
    meta: {"middleware":["external-redirect"]},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/[profileIdOrAlias]/edit-availability.vue")
  }
]
  },
  {
    name: "experiences",
    path: "/experiences",
    meta: { ...(experiences_46clientPVYt_ambgcX4_CtSQ5C6fnpcVQiAuq1UpuRuqIMBS90Meta || {}), ...{"middleware":["auth"]} },
    component: () => createClientPage(() => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/experiences.client.vue")),
    children: [
  {
    name: "experiences-experienceId",
    path: ":experienceId()",
    component: () => createClientPage(() => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/experiences/[experienceId].client.vue"))
  }
]
  },
  {
    name: "mf-profile-sandbox",
    path: "/mf/profile/sandbox",
    meta: sandboxv4onpqxEL3IXU47Zkhml7H0qyc3viE6Cvtmj6Ufa0JgMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/mf/profile/sandbox.vue")
  },
  {
    name: "recommendations",
    path: "/recommendations",
    meta: { ...(indexI_45rMbTYDljsWTLf_Deo0Fh_bvjIc8fXeB3JxzG5JXwsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/recommendations/index.vue")
  },
  {
    name: "freelancer-signup-demo",
    path: "/freelancer-signup/demo",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/demo.vue")
  },
  {
    name: "freelancer-signup",
    path: "/freelancer-signup",
    meta: indexczYuNOGpgeSZl_lyA4PIvW3DqosReQImlPeGWwbKtAwMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index.vue"),
    children: [
  {
    name: "freelancer-signup-index-your-skills",
    path: "your-skills",
    meta: your_45skillsdsrZDs95tnydRDc9En9vj78L59ExaHN6Ed6ZaWTibPoMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-skills.vue")
  },
  {
    name: "freelancer-signup-index-welcome-back",
    path: "welcome-back",
    meta: welcome_45backjoHl9SIAFNlqTbJTUQd4XejR46lYVTC2LwKHZFk_45mD8Meta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/welcome-back.vue")
  },
  {
    name: "freelancer-signup-index-your-education",
    path: "your-education",
    meta: your_45educationYYgegX3zzXSsPluMj3wSshAeTPdPAk6xWV96on4RxYMMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-education.vue")
  },
  {
    name: "freelancer-signup-index-your-daily-rate",
    path: "your-daily-rate",
    meta: your_45daily_45rateIqDTUGR3cIR5Cf74rLXE4ihES2xxkYLGXVZRAKSXdU8Meta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-daily-rate.vue")
  },
  {
    name: "freelancer-signup-index-your-top-skills",
    path: "your-top-skills",
    meta: your_45top_45skillsEHrO0hpvd5TFSR0dZB4kMuS_457QuX4_eSvhCGAQqAtH8Meta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-top-skills.vue")
  },
  {
    name: "freelancer-signup-index-verify-your-email",
    path: "verify-your-email",
    meta: verify_45your_45emailFSEEMi_45oDdH5EzOL_9o0jV0C1wBu5Cagni2jopplA50Meta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/verify-your-email.vue")
  },
  {
    name: "freelancer-signup-index-your-phone-number",
    path: "your-phone-number",
    meta: your_45phone_45numberg24dHwSShtMigleoMKkc5MaCR6mMm8m69Zi51aW8WAgMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-phone-number.vue")
  },
  {
    name: "freelancer-signup-index-create-your-account",
    path: "create-your-account",
    meta: create_45your_45account1pYJh_45GapjMyoHuQa5ICnfRQdrNHqGRTpVvjNHZAM6MMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/create-your-account.vue")
  },
  {
    name: "freelancer-signup-index-redirect-to-regular",
    path: "redirect-to-regular",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/redirect-to-regular.vue")
  },
  {
    name: "freelancer-signup-index-welcome-to-malt-open",
    path: "welcome-to-malt-open",
    meta: welcome_45to_45malt_45openmv33wcI_45Wy3yFCbIJQ9rhMbkZxCoq9U5Mf5TjeClTTcMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/welcome-to-malt-open.vue")
  },
  {
    name: "freelancer-signup-index-your-profile-picture",
    path: "your-profile-picture",
    meta: your_45profile_45picture90CylNXRcS2je3uZH38ISYtpGRlET0TPQnzgareYewAMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-profile-picture.vue")
  },
  {
    name: "freelancer-signup-index-your-work-experience",
    path: "your-work-experience",
    meta: your_45work_45experiencegtEuz8FbxIO5Rz8_455c1slB1o8VNrxhQ6f9Or3VaNLEwMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-work-experience.vue")
  },
  {
    name: "freelancer-signup-index-complete-your-account",
    path: "complete-your-account",
    meta: complete_45your_45accountTsyoDkU5zcSbL7PMhOGrVFgyHaf4ObKQ4QgC5McW5B4Meta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/complete-your-account.vue")
  },
  {
    name: "freelancer-signup-index-showcase-your-talents",
    path: "showcase-your-talents",
    meta: showcase_45your_45talentskO1RY7vwfb_Zh_0F7wYS7srYu3r96oatLM6tNzxzhGoMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/showcase-your-talents.vue")
  },
  {
    name: "freelancer-signup-index-your-privacy-settings",
    path: "your-privacy-settings",
    meta: your_45privacy_45settingsRmnaYGb9uRfNb9BxiWbgk4V3S3PYTFX_457Fz_457_hSExMMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-privacy-settings.vue")
  },
  {
    name: "freelancer-signup-index-your-working-languages",
    path: "your-working-languages",
    meta: your_45working_45languagesf6gpn_2xxlP0aENrrEhVzTUwzWch35pJ683B1ienAX8Meta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-working-languages.vue")
  },
  {
    name: "freelancer-signup-index-submit-your-application",
    path: "submit-your-application",
    meta: submit_45your_45applicationKKME21288OeKXz1EaNP_IEdEYbK_Gy7r3LRg6np3Xt0Meta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/submit-your-application.vue")
  },
  {
    name: "freelancer-signup-index-your-industry-expertise",
    path: "your-industry-expertise",
    meta: your_45industry_45expertiseDJcndSYjbO5d7zlLBBITM69LxS5SCCMmJvNa87makAgMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-industry-expertise.vue")
  },
  {
    name: "freelancer-signup-index-welcome-to-malt-strategy",
    path: "welcome-to-malt-strategy",
    meta: welcome_45to_45malt_45strategyyqBlEnTW2bhOmHTNToUmE6YhryJ2jcs5DBLNvZWN6icMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/welcome-to-malt-strategy.vue")
  },
  {
    name: "freelancer-signup-index-your-level-of-experience",
    path: "your-level-of-experience",
    meta: your_45level_45of_45experience8aIMPZD06uBM1OhcdBFAyo7GGpZetqEeV8_45DX61OnqcMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-level-of-experience.vue")
  },
  {
    name: "freelancer-signup-index-create-your-account-split",
    path: "create-your-account-split",
    meta: create_45your_45account_45splitW2k_45FUdidGcLw0kAFbbs6svK47TlSgZhLmk7lcteWBkMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/create-your-account-split.vue")
  },
  {
    name: "freelancer-signup-index-your-freelancing-experience",
    path: "your-freelancing-experience",
    meta: your_45freelancing_45experienceINAG2jCy4j3dedtQkoOhjvMoEetg4mBNECVE0fJy6u4Meta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-freelancing-experience.vue")
  },
  {
    name: "freelancer-signup-index-your-job-title-and-category",
    path: "your-job-title-and-category",
    meta: your_45job_45title_45and_45categoryqVRLbwVuiR6qGACuVI3DFtZM9B5m5zzCnlZp50tbvnEMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-job-title-and-category.vue")
  },
  {
    name: "freelancer-signup-index-how-would-you-describe-yourself",
    path: "how-would-you-describe-yourself",
    meta: how_45would_45you_45describe_45yourselfU2VEp4azGSO8Q5nTQL0viuEN8P7mrw8BEdnyX939JBEMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/how-would-you-describe-yourself.vue")
  },
  {
    name: "freelancer-signup-index-welcome-to-maltfunnelContext",
    path: "welcome-to-malt:funnelContext?",
    meta: welcome_45to_45malt_91_91funnelContext_93_93VROXo3dE_fqUAxqXdkZW_YjDmUPG9lE6vqIY73dgYXAMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/welcome-to-malt[[funnelContext]].vue")
  },
  {
    name: "freelancer-signup-index-your-location-and-workplace-preference",
    path: "your-location-and-workplace-preference",
    meta: your_45location_45and_45workplace_45preference2z5CNnwsA2QueaqwXSY_45_45c8ouA_459td_45iLie3ktjdB2cMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/index/your-location-and-workplace-preference.vue")
  }
]
  },
  {
    name: "freelancer-charter",
    path: "/freelancer-charter",
    meta: indexTzqiNYKN_45X1Qrv06ZxN3ElzxqL_RbHWkjG1NT9DeZQUMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-charter/index.vue")
  },
  {
    name: "cv-profileIdOrAlias-pdf",
    path: "/cv/:profileIdOrAlias()/pdf",
    meta: { ...(pdfwwGd20Eu8cjkwmtgiOgCPTSMbl9Oiw5Jlgmjuft1rr4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/cv/[profileIdOrAlias]/pdf.vue")
  },
  {
    name: "mission-preferences",
    path: "/mission-preferences",
    meta: { ...(index1GepqszjwZxnn9gP3JoKEhf8gQQOZCAmwcjq43GzbYYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/mission-preferences/index.vue")
  },
  {
    name: "cv-profileIdOrAlias",
    path: "/cv/:profileIdOrAlias()",
    meta: { ...(indexk0hvrFdVlc1E6_451S04eP_45ukf5SylrE1IYR7IZg6VKsoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/cv/[profileIdOrAlias]/index.vue")
  },
  {
    name: "edit-availability-profileId",
    path: "/edit-availability/:profileId()",
    meta: _91profileId_93XcZ7P3zthTJ9C6nYjdZkoL6n6Lsp5PTuCOsfa_owfckMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/edit-availability/[profileId].vue")
  },
  {
    name: "mf-profile-profileIdOrAlias",
    path: "/mf/profile/:profileIdOrAlias()",
    meta: _91profileIdOrAlias_93ES8vP6rp7Xu0IYWhoNdojBdumI1PBf0LjfYNuVWN6uEMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/mf/profile/[profileIdOrAlias].vue")
  },
  {
    name: "reputation-provider-auth-confirmed",
    path: "/reputation-provider/auth-confirmed",
    meta: auth_45confirmedsPkaXH5XwTLoupUZJUnzQzGC15l4uPXP9hXM14omEb8Meta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/reputation-provider/auth-confirmed.vue")
  },
  {
    name: "mf-profile-qualification-panel-starter",
    path: "/mf/profile-qualification-panel/starter",
    meta: starterVIM_JA9ERBK9r8cFFodkirQ8zZFUTX9nbr_vZ12IyQsMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/mf/profile-qualification-panel/starter.vue")
  },
  {
    name: "freelancer-signup-waiting-room-strategy",
    path: "/freelancer-signup/waiting-room/strategy",
    meta: { ...(strategyM2Z1tJHbR4YC9N1IDs4GXQKXaKtlzEA0f87Q3y_45KHBoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/waiting-room/strategy.vue")
  },
  {
    name: "freelancer-signup-reminder-reminderToken",
    path: "/freelancer-signup/reminder-:reminderToken()",
    meta: reminder_45_91reminderToken_93jlFaoaPnLHMdyaUzgv7AbCSEByVvOS2lOEljulvEEZsMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/profile/profile-front/src/pages/freelancer-signup/reminder-[reminderToken].vue")
  }
]